var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMicrophoneFilled = function SvgMicrophoneFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-20": 14,
    "data-width-24": 14,
    viewBox: "0 0 14 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.988 0c.796 0 1.559.3 2.122.832.562.533.878 1.256.878 2.01v5.684c0 .754-.316 1.477-.878 2.01a3.1 3.1 0 0 1-2.122.832c-.795 0-1.558-.299-2.121-.832a2.77 2.77 0 0 1-.879-2.01V2.842c0-.754.316-1.477.879-2.01A3.1 3.1 0 0 1 6.988 0m6.6 8.526c.221 0 .402.18.388.4-.199 3.162-2.734 5.72-5.988 6.166V17.6a.4.4 0 0 1-.4.4h-1.2a.4.4 0 0 1-.4-.4v-2.508C2.734 14.646.2 12.088.001 8.926a.38.38 0 0 1 .387-.4h1.2c.221 0 .398.18.418.4.1 1.11.609 2.156 1.447 2.95a5.15 5.15 0 0 0 3.535 1.387c1.326 0 2.598-.499 3.536-1.387a4.63 4.63 0 0 0 1.447-2.95.43.43 0 0 1 .417-.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMicrophoneFilled);
export default ForwardRef;